import axios from "axios" 

const instance = axios.create({
    baseURL: 'https://nabojagorn-academy-server.vercel.app/api/v1',
    headers: {
        'content-type': 'application/json',
        'authorization': `Bearer ${localStorage.getItem('accessToken')}`                    
    }
  });

export default instance;